import { type Type_IActionType, Type_isFlowActionType } from '../Type/Type.hive'

export function Acti_getFlowsInActivities(activities: Type_IActionType[]) {
    return activities.filter(Type_isFlowActionType).map((at) => at.flow)
}
